import { LOGIN_TYPE } from '../types';
import { getMarket } from './helpers';
import Logger from '../logger';

const isVersionGreater = (version1, version2) => {
    if (!version1) {
        return false;
    }

    const v1Components = version1.split('.').map(Number);
    const v2Components = version2.split('.').map(Number);

    const maxLength = Math.max(v1Components.length, v2Components.length);

    for (let i = 0; i < maxLength; i++) {
        const v1 = v1Components[i] || 0; // Use 0 if the component is missing
        const v2 = v2Components[i] || 0; // Use 0 if the component is missing

        if (v1 > v2) {
            return true;
        } else if (v1 < v2) {
            return false;
        }
    }

    return false;
};

const isNewVersion = (version) => {
    return isVersionGreater(version, '5.104.0.13567');
};

const getCommonData = (args) => {
    const getLastName = (args) =>
        args.msisdn
            ? args.msisdn
            : args.userIdentificationNumber
            ? args.userIdentificationNumber
            : 'niezidentyfikowany';
    const isNameRequired =
        !args.loginType || args.loginType === 'none' || args.loginType === 'quick';

    const getGlobalVisitId = () => {
        if (!window._gt || !window._gt.getConfig) {
            return null;
        }
        const config = window._gt.getConfig();
        if (config) {
            return config.internal?.globalVisitID;
        }
        return null;
    };
    const globalVisitId = getGlobalVisitId();

    const newVersion = isNewVersion(args.verMO);

    const syneriseUUID = window.WC._cookies.getCookie('_snrs_uuid');
    if (!syneriseUUID) {
        Logger.log('no _snrs_uuid');
    }

    return {
        ...(isNameRequired && { firstName: 'Klient' }),
        ...(isNameRequired && { lastName: getLastName(args) }),
        additionalData: {
            'typ zalogowania': LOGIN_TYPE[args.loginType ? args.loginType : 'none'],
            'wersja Widget Contact': process.env.WC_VERSION,
            źródło: args.verMO ? 'aplikacja MO' : 'www',
            ...(args.verMO && {
                'wersja aplikacji MO': args.verMO
            }),
            rynek: getMarket(args),
            'numer klienta':
                args.userIdentificationNumber && !newVersion ? args.userIdentificationNumber : '',
            'numer MSISDN': args.msisdn && !newVersion ? args.msisdn : '',
            ...(globalVisitId && {
                globalVisitId: globalVisitId
            }),
            ...(args.initParams && {
                initParams: args.initParams
            }),
            ...(args.orderNumber && {
                orderNumber: args.orderNumber
            }),
            ...(args.orderDetails && {
                // TODO: remove stringify and check Kibana if events with input are present
                orderDetails: JSON.stringify(args.orderDetails)
            }),
            ...(syneriseUUID && {
                _snrs_uuid: syneriseUUID
            })
        }
    };
};

export default getCommonData;
